import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '../helper/helper.service';
/**
 * This is a custom pipe to format the date based on arguments, We have used the moment to format the dates
 */
@Pipe({
  name: 'date'
})
export class DatePipe implements PipeTransform {
  constructor(private helper: HelperService){}

  transform(value: any, args?: any): any {
    return this.helper.dateFormat(value, args);
  }

}
